<template>
  <div class="draughts skew-11-neg">
    <div class="text-section">
      <div class="text-section-title">Ancient Brain Draughts Game</div>
      <div class="text-section-content">
        As part of my B.Sc. studies at <a href="https://www.dcu.ie/" target="_blank" rel="noreferrer nofollow">DCU</a> I created a basic draughts game using JavaScript with the <a href="https://threejs.org/" target="_blank" rel="noreferrer nofollow">Three.js</a> library. I wrote this as a submission to a website created by <a href="https://computing.dcu.ie/~humphrys/" target="_blank" rel="noreferrer nofollow">Dr. Mark Humphrys</a> called <a href="https://ancientbrain.com/" target="_blank" rel="noreferrer nofollow">Ancient Brain</a> which allows people to share coding projects in the form of "Worlds" and "Minds". The game can be played <a href="https://run.ancientbrain.com/run.php?world=8392146989&mind=5349637596" target="_blank" rel="noreferrer nofollow">here on Ancient Brain</a>!
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'draughts',
  };
</script>

<style scoped lang="less">
  @import "../common/colors";

</style>


// WEBPACK FOOTER //
// src/components/Draughts.vue?2b72923b